import { render, staticRenderFns } from "./AdminUserAdd.vue?vue&type=template&id=5a4c33ac"
import script from "./AdminUserAdd.vue?vue&type=script&lang=js"
export * from "./AdminUserAdd.vue?vue&type=script&lang=js"
import style0 from "./AdminUserAdd.vue?vue&type=style&index=0&id=5a4c33ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports